import { render, staticRenderFns } from "./UpsertContactPropertyConfig.vue?vue&type=template&id=386e30d3&scoped=true"
import script from "./UpsertContactPropertyConfig.vue?vue&type=script&lang=js"
export * from "./UpsertContactPropertyConfig.vue?vue&type=script&lang=js"
import style0 from "./UpsertContactPropertyConfig.vue?vue&type=style&index=0&id=386e30d3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "386e30d3",
  null
  
)

export default component.exports